import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount } from 'react-nb-hooks'
import { Segment, Grid, Dropdown } from 'semantic-ui-react'
import createAction from 'loankeeper-common/helpers/createAction'
import { LKHeader } from 'loankeeper-common/components'
// @ts-ignore
import { GridContainer, FakeInput, ComponentContainer } from 'shared/StyledComponents'

import { transLabel } from '../../../helpers'
import { actions, REDUCER_NAME } from './constants'
import { Base, ReappriseData } from '../../CollateralDetailsTabs.types'

const getInstance = (state, ID: number) => state.CollateralDetails[REDUCER_NAME][ID] || {}
const getReappriseID = (state, ID: number) => getInstance(state, ID).reappriseID

const Reestimate = React.memo(
  ({ ID, reappriseItems, base }: { ID: number; reappriseItems: ReappriseData[]; base: Base }) => {
    const dispatch = useDispatch()

    const { reappriseID, reapprisedValue } = useSelector((state) => {
      const reappriseIDValue = getReappriseID(state, ID)

      return {
        reappriseID: reappriseIDValue,
        reapprisedValue: reappriseIDValue && reappriseItems.find((item) => item.ID === reappriseIDValue).Price,
      }
    })

    useMount(() => {
      if (!reappriseID) {
        dispatch(createAction(actions.INITIALIZE, { reappriseID: reappriseItems[0].ID }, { ID }))
      }
    })

    function handleReapprise(_, { value }) {
      dispatch(createAction(actions.REAPPRISE, { reappriseID: value }, { ID }))
    }

    return (
      <Segment>
        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                {transLabel('currestim')}
              </Grid.Column>

              <Grid.Column width={3} verticalAlign="middle">
                <FakeInput>
                  <Segment>
                    <LKHeader size="small">{base.Price}</LKHeader>
                  </Segment>
                </FakeInput>
              </Grid.Column>

              <Grid.Column width={4} textAlign="right" verticalAlign="middle">
                {transLabel('reestimate')}
              </Grid.Column>

              <Grid.Column width={3} verticalAlign="middle">
                <ComponentContainer dropdown>
                  <Dropdown
                    fluid
                    search
                    selection
                    upward
                    value={reappriseID}
                    onChange={handleReapprise}
                    options={reappriseItems.map((item) => ({
                      value: item.ID,
                      text: item.Title,
                    }))}
                  />
                </ComponentContainer>
              </Grid.Column>

              <Grid.Column width={3} verticalAlign="middle">
                <FakeInput>
                  <Segment>
                    <LKHeader size="small">{reapprisedValue && reapprisedValue.toFixed(2)}</LKHeader>
                  </Segment>
                </FakeInput>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>
      </Segment>
    )
  },
)

export default Reestimate
